import React from "react"
import Detail from "../Detail"
import { PCViewRoot } from "../Common/PCViewContext"

const DetailPage = (props) => {
  return (
    <PCViewRoot>
      <Detail {...props} />
    </PCViewRoot>
  )
}
export default DetailPage
